import React from 'react'

export default class DisplayGroupDtails extends React.Component {
    render() {
        return <div className="product-info-details">{this.props.children}</div>
    }
}
